import React from 'react'
import PropTypes from 'prop-types'
import { Button, Icon } from 'antd'

const CreatorListSaveAndFork = function (props) {
  let displayStatus
  let saveStatusClassName
  if (props.status === 'SAVED') {
    displayStatus = 'Saved'
    saveStatusClassName = 'list-saved'
  } else if (props.status === 'SAVING') {
    displayStatus = 'Saving...'
    saveStatusClassName = 'list-saving'
  }

  return (
    <div className='list-save-and-fork'>
      <div id='list-save-status' className={saveStatusClassName}>
        {displayStatus}
      </div>
      <Button id='list-copy-button' onClick={props.forkList}>
        <Icon type='copy' theme='outlined' />
        Copy
      </Button>
    </div>
  )
}

CreatorListSaveAndFork.propTypes = {
  forkList: PropTypes.func.isRequired,
  status: PropTypes.oneOf(['SAVED', 'SAVING']).isRequired
}

export default CreatorListSaveAndFork



// WEBPACK FOOTER //
// ./src/components/CreatorListSaveAndFork.js